import classNames, { Argument } from 'classnames';

export const classNamesWithAntialiasing = (antialiased: boolean, ...args: Argument[]) => {
  return classNames(...args, { antialiased });
};
